import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["error"]

  disconnect() {
    this.element.classList.remove("community-editor--dragging")
  }

  dragover(event) {
    if (!Array.from(event.dataTransfer?.types || []).includes("Files")) return
    event.preventDefault()
    event.dataTransfer.dropEffect = "copy"
    this.element.classList.add("community-editor--dragging")
  }

  dragleave(event) {
    if (!this.element.contains(event.relatedTarget)) this.disconnect()
  }

  drop(event) {
    const files = Array.from(event.dataTransfer?.files || [])
    if (!files.length) return
    event.preventDefault()
    this.disconnect()
    const inputs = Array.from(this.element.querySelectorAll('input[type="file"][accept]'))
    const additions = new Map(inputs.map(input => [input, []]))
    let rejected = false

    files.forEach(file => {
      const input = inputs.find(input => !input.disabled && this.accepts(input, file))
      if (input) additions.get(input).push(file)
      else rejected = true
    })

    additions.forEach((added, input) => {
      if (!added.length) return
      const transfer = new DataTransfer()
      Array.from(input.files).concat(added).forEach(file => transfer.items.add(file))
      input.files = transfer.files
      input.dispatchEvent(new Event("change", { bubbles: true }))
    })
    this.errorTarget.hidden = !rejected
  }

  accepts(input, file) {
    return input.accept.toLowerCase().split(",").some(value => {
      const type = value.trim()
      if (type.startsWith(".")) return file.name.toLowerCase().endsWith(type)
      if (type.endsWith("/*")) return file.type.toLowerCase().startsWith(type.slice(0, -1))
      return file.type.toLowerCase() === type
    })
  }
}
